const leverageOptions = [
  { value: 30, leverageRange: [1, 30] },
  { value: 1000, leverageRange: [31, 1000] },
];

export default leverageOptions;
